<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import gotoNextModalMixin from './mixins/gotoNextModal';

export default {
	name: 'App',
	mixins: [gotoNextModalMixin],
	computed: {
		...mapGetters(['getErrorMessage'])
	},
	watch: {
		getErrorMessage(val) {
			// log to mixpanel
			this.mixpanelTracker({
				step_name: 'Error',
				distinct_id: this.getDistinctId,
				payload: { error: val }
			});
		}
	},
	created() {
		window.addEventListener('message', this.receiveDataFromPaymentLinkIframe, false);
	},
	methods: {
		// listens to response from payment link redirect url
		async receiveDataFromPaymentLinkIframe(event) {
			if (event && event.data && event.data === '"successful"') {
				const body = document.getElementsByTagName('body')[0];
				const paymentElement = document.getElementById('payment');
				body.removeChild(paymentElement);
				this.$store.commit('setHideKlumpFlow', true);
			}
		}
	}
};
</script>
